import React from "react";
import StockRegister from "../StockRegister";

export default function StockPortal() {
    return <StockRegister heading="Stock Register" eyebrow="Inventory · Tally-style" />;
}
